import { Dialog } from "primereact/dialog";
import { Panel } from 'primereact/panel';
import { Button } from "primereact/button";

import { IBranchMastDropdown, ICompanyMastDropdown, ISkillCategoriesDropdown } from "../../models/IDropdown";

import { useEffect, useState } from "react";
import { Fetch, ILazyParams, baseUrl } from "../../shared/Fetch";
import { MultiSelect } from "primereact/multiselect";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { IModel } from "./SkillTeamManagement";
import { AttendanceHistoryTable } from "../attendanceMark/Table";
import { IUserMast } from "../../models/UserMast";
import { JVDropdown } from "../../shared/JVDropdown";
import { useForm } from "react-hook-form";
import { ILogin, IPermissionProps } from "../../models/Login";


interface Iprops {
    singleData: any,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    setModal: (modal: IModel) => void,
    setModal3: (modal: {
        open: boolean,
        singleData: any,
        inTeam: any,
        p: number | null,
        s: number | null
    }) => void,
    permissions: IPermissionProps,
}

interface Users {
    branch_ID?: number,
    login_ID?: number,
    user_Name?: string,
}

interface Team {
    branch?: string,
    branch_ID?: number,
    company?: string,
    company_ID?: number,
    createdOn?: Date,
    status?: boolean,
    team_ID?: number,
    team_Manager?: string,
    team_Manager_ID?: number,
    team_Name?: string,
    user_Added_by?: number,
}

interface RowData {
    login_ID: number,
    teamMember_ID: number,
    team_ID: number,
    user_Name: string,
    temp_Inactive: boolean,
    user_Status: string

}

export const SkillTeamMembersForm = (props: Iprops) => {
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [company, setCompany] = useState(null as ICompanyMastDropdown | null);
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [branch, setBranch] = useState(null as IBranchMastDropdown | null);
    const [diable, setDisable] = useState({ branch: true, teamMembers: true });
    const [users, setUsers] = useState<Array<Users>>();
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<any>, loading: boolean });
    const [moveModal, setMoveModal] = useState({ open: false, user_ID: 0 } as { open: boolean, user_ID: number });
    const [team, setTeam] = useState<Array<Team>>([]);
    const [selectedTeam, setSelectedTeam] = useState([]);
    const [selectedTeamMembers, setSelectedTeamMembers] = useState([]);
    const [disableOnSubmit, setDisableOnSubmit] = useState(false);
    const [disableOnSubmitMoveModal, setDisableOnSubmitMoveModal] = useState(false);
    const [disableMove, setDisableMove] = useState(false);
    const [disableRemove, setDisableRemove] = useState(false);
    const [attendanceTable, setAttendanceTable] = useState({ user_id: 0, open: false } as { user_id: number, open: boolean });
    const [skillCategories, setSkillCategories] = useState<Array<ISkillCategoriesDropdown>>();
    const [primarySkills, setPrimarySkills] = useState(null as number | null);
    const [secondarySkills, setSecondarySkills] = useState(null as number | null);


    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'consultant_ID',
        sortOrder: -1
    });

    const _roles: Array<number> = [];
    const loginObj2: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj2.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    let x: string | null = sessionStorage.getItem('auth') || "null";
    let loginObj = JSON.parse(x);

    const { control, watch, formState: { errors }, reset } = useForm<any>({
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    const loadTeamMembers = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("TeamMember_Skill_Mast", "GET", null, `team_Id=${props.singleData.team_ID}`, null);
        if (response) {
            const data = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    const loadCompanies = async () => {
        setBranch(null);
        const response = await Fetch("Dropdown/company", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            setCompanies(data);
        }
    }

    const loadBranches = async () => {
        setUsers([]);
        const response = await Fetch("Dropdown/branches", "GET", null, `company_id=${company}`, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            setBranches(data);
        }
    }

    const loadUsers = async () => {
        const response = await Fetch((loginObj2.is_Team_Lead === true && ((_roles[0] === 3 || _roles[0] === 21) && _roles.length === 1)) ? "Dropdown/getTeamMembers" : "Team_Skill_Mast/RecuitersByBranch", "GET", null, (loginObj2.is_Team_Lead === true && ((_roles[0] === 3 || _roles[0] === 21) && _roles.length === 1)) ? `company_Id=${company}&branch_Id=${branch}` : `branch_ID=${branch}`, null);
        if (response) {
            const data: Array<Users> = await response.json();
            let resp = [];
            for (let i = 0; i < data.length; i++) {
                let yes = true;
                for (let j = 0; j < tableData.tableData.length; j++) {
                    if (data[i].login_ID === tableData.tableData[j].login_ID || data[i].login_ID === props.singleData.team_Manager_ID) {
                        yes = false;
                        j = tableData.tableData.length;
                    }
                }
                if (yes) {
                    resp.push(data[i]);
                }
            }
            setUsers(resp);
        }
    }

    const loadTeams = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Team_Skill_Mast", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}`, props.toast);
        if (response) {
            const data: Array<Team> = await response.json();
            setTeam(data);
        }
    }

    useEffect(() => {
        loadCompanies();
        if (props.open) {
            loadTeamMembers();
            setSelectedTeamMembers([]);
            setSelectedTeam([]);
            if (company != null) {
                setDisable({ branch: false, teamMembers: true });
                loadBranches();
            } else {
                setDisable({ branch: true, teamMembers: true });
            }
        }
    }, [props.open]);
    useEffect(() => {
        if (company != null) {
            loadBranches();
        }
    }, [company]);
    useEffect(() => {
        if (branch != null) {
            loadUsers();
        }
    }, [branch]);
    useEffect(() => {
        loadTeams();
    }, [moveModal.open]);

    const saveToDB = async (body: any) => {
        const teamMembersList = body.list.map((el: number) => {
            let user = {
                Team_ID: body.ud === 0 ? props.singleData.team_ID : body.ud,
                Login_ID: el,
                Status: true,
                User_Added_by: loginObj.id,
                CreatedOn: null,
            };
            return user;
        });


        const response = await Fetch("TeamMember_Skill_Mast", "POST", teamMembersList, ``, props.toast);
        if (response) {
            const resp = await response.json();
            loadTeamMembers();
            setSelectedTeamMembers([]);
            setSelectedTeam([]);
            setDisableOnSubmit(false);
            setDisableOnSubmitMoveModal(false);
            if (resp.length > 0) {
                let list = resp.filter((el: { on_Team_ID: number; }) => el.on_Team_ID != props.singleData.team_ID);
                if (list.length > 0) {
                    props.setModal3({ singleData: list, open: true, inTeam: props.singleData, p: primarySkills, s: secondarySkills })
                    props.setReload(!props.reload);
                } else {
                    props.toast.current.show({ severity: 'success', detail: "Already Present In This Team", life: 3000 });
                    props.setReload(!props.reload);
                }
            } else {
                props.toast.current.show({ severity: 'success', detail: "Added Successfully", life: 3000 });
                props.setReload(!props.reload);
            }
        } else {
            setDisableOnSubmit(false);
        }
    }

    const selectCompany = (e: ICompanyMastDropdown) => {
        setCompany(e);
        setBranch(null);
        if (e) {
            setDisable({ branch: false, teamMembers: true });
        } else {
            setDisable({ branch: true, teamMembers: true });
        }
    }
    const selectBranch = (e: IBranchMastDropdown) => {
        setBranch(e);
        if (e) {
            setDisable({ branch: false, teamMembers: false });
        } else {
            setDisable({ branch: false, teamMembers: true });
        }
    }

    const onHide = () => {
        props.hideDialog();
        setBranch(null);
        setCompany(null);
        setUsers([]);
        setSelectedTeamMembers([]);
        setPrimarySkills(null);
        setSecondarySkills(null);
        setDisableOnSubmit(false);
    }
    const onHideMoveModal = () => {
        setMoveModal({ open: false, user_ID: 0 });
        loadTeamMembers();
        setSelectedTeam([]);
    }

    function onSubmit() {
        if (selectedTeamMembers.length == 0) {
            props.toast.current.show({ severity: 'error', detail: "Please select atleast one team member", life: 3000 });
            setDisableOnSubmit(false);
        } else if ((primarySkills === null || primarySkills === 0) || (secondarySkills === null || secondarySkills === 0)) {
            props.toast.current.show({ severity: 'error', detail: "Please select Primary Skills and Secondary Skills ", life: 3000 });
            setDisableOnSubmit(false);
        } else {
            setDisableOnSubmit(true);
            saveToDB({ list: selectedTeamMembers, ud: 0 });
        }
    }

    async function onMove() {
        if (selectedTeam.length === 0) {
            props.toast.current.show({ severity: 'error', detail: "Please select a team", life: 3000 });
        } else {
            setDisableOnSubmitMoveModal(true);
            let resp = await removeMember({ id: moveModal.user_ID, r: false });
            if (resp) saveToDB({ list: [moveModal.user_ID], ud: selectedTeam });
            onHideMoveModal();
        }
    }

    async function removeMember(data: { id: number, r: boolean }) {
        setDisableRemove(true);
        const params = {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            },
        };

        const response = await fetch(`${baseUrl}TeamMember_Skill_Mast?user_IDs=${[data.id]}`, params);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Member Removed", life: 3000 });
            if (data.r) {
                loadTeamMembers();
            }
            setDisableRemove(false);
            return true;
        }
    }

    const onHideHistoryTable = () => {
        setAttendanceTable({ user_id: 0, open: false });
    }

    const MoveRemove = (rowData: RowData) => {
        return (<div className="w-full flex justify-content-evenly">
            <Button icon="pi  pi-arrow-circle-right" className="text-primary bg-white border-none" disabled={disableMove} onClick={() => setMoveModal({ open: true, user_ID: rowData.login_ID })} tooltip="Move" tooltipOptions={{ position: 'bottom', mouseTrack: true, mouseTrackTop: 15 }} />
            <Button icon="pi pi-trash" className="border-none" style={{ backgroundColor: 'white', borderColor: 'red', color: 'red' }} disabled={disableRemove} onClick={() => removeMember({ id: rowData.login_ID, r: true })} tooltip="Delete" tooltipOptions={{ position: 'bottom', mouseTrack: true, mouseTrackTop: 15 }} />
        </div>);
    }
    const toggleVal = async (login_id: number, toggle_type: number) => {
        const response = await Fetch("User_Mast/toggle", "PUT", null, `login_id=${login_id}&toggle_type=${toggle_type}`, props.toast);
        if (response) {
            // let message: string = toggle_type === 1 ? "User Status Changed" : toggle_type === 2 ? "Temp Status Changed" : "Work From Changed";
            let message: string = "User Status Changed";
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            loadTeamMembers();
        }
    };

    const user_TStatus = (rowData: IUserMast) => {
        return (
            <span style={{ color: rowData.temp_Inactive ? 'red' : 'green' }} className="cursor-pointer" onClick={() => {
                if (rowData.login_ID && ((_roles.includes(1) || _roles.includes(4)) || (loginObj2.id === 1346 && props.singleData.teamManagerid === 1346) || (loginObj2.is_Team_Lead === true && ((_roles.includes(3) || _roles.includes(6) || _roles.includes(21)))))) {

                    toggleVal(rowData.login_ID, 2)
                }
            }}>{rowData.temp_Inactive ? "No" : "Yes"}</span>
        );

    };
    const loadSelecetdSkillCategories = async () => {
        const response = await Fetch("Team_Skill_Mast/getSkillsCategories", "GET", null, `team_id=${props.singleData.team_ID}`, null);
        if (response) {
            const data: Array<ISkillCategoriesDropdown> = await response.json();
            const emptyData = {
                req_CategoryID: 0,
                req_CategoryName: "-- SELECT --",
            };
            data.unshift(emptyData);
            setSkillCategories(data);
        }
    }

    useEffect(() => {
        if (props.open) loadSelecetdSkillCategories();
    }, [props.open]);

    return (
        <>
            <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Team Members" modal className="p-fluid" onHide={onHide}>
                <div className="flex">
                    <Panel header="Team Name" className="w-3">
                        <p className="m-0">{props.singleData.team_Name}</p>
                    </Panel>
                    <Panel header="Company" className="w-3">
                        <p className="m-0">{props.singleData.company}</p>
                    </Panel>
                    <Panel header="Branch" className="w-3">
                        <p className="m-0">{props.singleData.branch}</p>
                    </Panel>
                    <Panel header="Team Manager" className="w-3">
                        <p className="m-0">{props.singleData.team_Manager}</p>
                    </Panel>
                </div>
                <div className="flex align-content-center mt-6 gap-3">
                    <div>
                        <label>Company</label>
                        <Dropdown value={company} onChange={(e: any) => selectCompany(e.value)} options={companies} optionValue="company_ID" optionLabel="company_Name" placeholder="Select a Company" className="w-full md:w-14rem" showClear />
                    </div>
                    <div>
                        <label>Branch</label>
                        <Dropdown value={branch} disabled={diable.branch} onChange={(e: any) => selectBranch(e.value)} options={branches} optionLabel="branchName" optionValue="branch_ID" placeholder="Select a Branch" className="w-full md:w-14rem" showClear />
                    </div>
                    <div>
                        <label>Primary Skills</label>
                        <Dropdown value={primarySkills} name="req_Category" onChange={(e: any) => setPrimarySkills(e.value)} options={skillCategories} optionLabel="req_CategoryName" optionValue="req_CategoryID" placeholder="Select Primary Skills" className="w-full md:w-14rem" showClear />
                    </div>
                    <div>
                        <label>Secondary Skills</label>
                        <Dropdown value={secondarySkills} name="req_Category" onChange={(e: any) => setSecondarySkills(e.value)} options={skillCategories} optionLabel="req_CategoryName" optionValue="req_CategoryID" placeholder="Select Secondary Skills" className="w-full md:w-14rem" showClear />
                    </div>
                </div>
                <div className="flex align-content-center mt-1 gap-3">
                </div>
                <div className="flex align-content-center mt-3 gap-3">
                    <MultiSelect value={selectedTeamMembers} disabled={diable.teamMembers} onChange={(e) => setSelectedTeamMembers(e.value)} options={users} optionValue="login_ID" optionLabel="user_Name" display="chip" filter placeholder="Select Members" maxSelectedLabels={10} className="w-11" />
                    <Button disabled={disableOnSubmit} className="h-3rem w-6rem" onClick={onSubmit}>SUBMIT</Button>
                </div>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                    className="mt-6"
                    size="small" stripedRows scrollable scrollHeight="30vh"
                    value={tableData.tableData}
                    emptyMessage="No Team Members found."
                    loading={tableData.loading}
                >
                    <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                    <Column field="user_Name" header="Team Member Name" />
                    <Column field="company_Name" header="Company Name" />
                    <Column field="branchName" header="Branch Name" />
                    <Column field="temp_Inactive" header="Present" body={user_TStatus} />
                    <Column field="user_Status" header="Status" body={(rowData) => <span style={{ color: rowData.user_Status ? 'red' : 'green' }}>{rowData.user_Status ? "Inactive" : "Active"}</span>} />
                    {(_roles.includes(1) || _roles.includes(4)) && <Column field="" header="History" body={(rowData) => <i className="cursor-pointer text-primary pi pi-history" onClick={() => setAttendanceTable({ user_id: rowData.login_ID, open: true })}></i>} />}
                    {((_roles.includes(1) || _roles.includes(4)) || props.permissions.is_Update) && <Column field="" header="" body={MoveRemove} />}
                </DataTable>
                <Dialog visible={attendanceTable.open} style={{ width: '80vw' }} header="History" modal className="p-fluid" onHide={onHideHistoryTable} >
                    <AttendanceHistoryTable user_ID={attendanceTable.user_id} />
                </Dialog>
            </Dialog>
            <Dialog visible={moveModal.open} style={{ width: '30vw' }} header="Move To Another Team" modal className="p-fluid" onHide={onHideMoveModal}>
                <div className="flex w-full justify-content-between">
                    <Dropdown showClear value={selectedTeam} onChange={(e) => setSelectedTeam(e.value)} options={team} optionLabel="team_Name" optionValue="team_ID" placeholder="Select a Team" className="w-full md:w-14rem" />
                    <Button className="w-5rem" disabled={disableOnSubmitMoveModal} onClick={onMove}>Move</Button>
                </div>
            </Dialog>
        </>
    );
}